var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.item.special_training ||
      _vm.item.location ||
      (_vm.item.visitors && _vm.item.visitors.length)
  )?_c('v-menu',{attrs:{"open-on-hover":"","close-on-content-click":false,"offset-y":"","bottom":"","lazy":""}},[_c('div',{attrs:{"slot":"activator","layout":"column","flex":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary","small":_vm.small}},[_vm._v(" mdi-alert ")])],1),_c('v-card',{staticStyle:{"width":"400px"}},[_c('v-card-text',[_vm._v("Special training, visitors or other location")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }